import { type Context, createContext } from 'react';

// The legacy rail shares the layout's remaining-height grid row, outside result scrolling.
// undefined is the original layout; null is the pinned layout before its portal target mounts.
export const PinnedRightPanelContext: Context<HTMLDivElement | null | undefined> = createContext<
	HTMLDivElement | null | undefined
>(undefined);
